import { useEffect, useState } from "react";

type ThemePreference = "system" | "light" | "dark";
declare global {
  interface Window {
    guildmasterTheme?: {
      getPreference(): ThemePreference;
      setPreference(value: ThemePreference): void;
    };
  }
}

export function ThemeControl() {
  const [preference, setPreference] = useState<ThemePreference>(
    () => window.guildmasterTheme?.getPreference() ?? "system",
  );
  useEffect(() => {
    const update = () =>
      setPreference(window.guildmasterTheme?.getPreference() ?? "system");
    window.addEventListener("guildmaster:theme", update);
    return () => window.removeEventListener("guildmaster:theme", update);
  }, []);
  return (
    <label className="theme-control">
      <span>Theme</span>
      <select
        value={preference}
        onChange={(event) =>
          window.guildmasterTheme?.setPreference(
            event.target.value as ThemePreference,
          )
        }
      >
        <option value="system">System</option>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
      </select>
    </label>
  );
}
